module.exports = __webpack_public_path__ + "img/2.e6b5c37c.png";